import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, HelpCircle } from "lucide-react";
import BottomMenu from "../../../../components/common/Authenticated/Menu/Menu";

function Suporte() {
  const navigate = useNavigate();

  const Voltar = () => {
    navigate("/area-restrita/minha-conta");
  };

  return (
    <>
      <div className="relative bg-white min-h-screen p-5 pb-8 sm:pb-24">
        {/* Botão voltar */}
        <button
          onClick={Voltar}
          className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9"
        >
          <ChevronLeft size={20} color="#fff" />
        </button>

        <div className="flex flex-col items-center mt-24 px-6 text-center max-w-[800px] mx-auto">
          <HelpCircle size={48} className="text-[#003D42] mb-4" />

          <h1 className="text-2xl font-semibold mb-4 text-black">Suporte</h1>
          <p className="text-gray-700 mb-4">
            Se você estiver enfrentando problemas, dúvidas ou precisar de ajuda, nossa equipe de suporte está pronta para ajudar.
          </p>
          <p className="text-gray-700">
            Entre em contato conosco pelo email:{" "}
            <a
              href="mailto:suporte@institutoselmacosso.com.br"
              className="text-[#003D42] font-semibold hover:underline"
            >
              suporte@institutoselmacosso.com.br
            </a>
          </p>
        </div>
      </div>
      <BottomMenu />
    </>
  );
}

export default Suporte;
